import $ from 'jquery';

import {getViewControllerName, getMetaContent, parseStringPriceToFloat} from './../general/Util.js';

const badgeUpdateFn = async function () {

    // Get needed HTML elements.
    const price_standard = document.getElementById("acl_article_price--default");
    const price_feed = document.getElementById("acl_article_price--feed");
    const voucher_code = document.getElementById("acl_feedvouchercode");

    // Check URL Parameters.
    const searchParams = new URLSearchParams(window.location.search);

    // Conditionals.
    const hasFeedParameter = searchParams.has('feed');
    const isExclusiveVoucher = searchParams.has('exclusivevoucher');

    if (hasFeedParameter) {
        await $.ajax({
            url: '/index.php?cl=acl_voucher_extensions_ajax&fnc=useFeedVoucher',
            method: 'POST',
            data: {
                artNr: window.exclusiveVoucherArticleId,
            },
            success: function (response) {
                try {
                    $.cookie('feedvouchercode', response);
                } catch (e) {

                }
            }
        });
    }

    const voucherCookie = $.cookie('feedvouchercode');
    const feedprice = $('#feedprice').data('unformatted-price');
    let showPromotion = voucher_code && voucherCookie && voucherCookie.length > 0 && feedprice > 0 ? true : false;

    let showExclusiveVoucher = false;
    let activeVoucherCode = '';
    if (isExclusiveVoucher) {
        activeVoucherCode = searchParams.get('exclusivevoucher');
    }
    await $.ajax({
        url: '/index.php?cl=acl_voucher_extensions_ajax&fnc=getActiveVoucher',
        method: 'POST',
        data: {
            exclusivevoucher: activeVoucherCode,
            productprice: $(price_standard).attr('data-priceval'),
            anid: $('input[name="aid"]').val()
        },
        success: function (response) {
            try {
                var parsed = JSON.parse(response);
                if (parsed && (parsed.price != null && parsed.price !== "undefined")) {
                    // $( '#acl_article_price--feed > .en_price--new' ).html( parsed.price );
                    let parsedFeedprice = parsed.price;
                    const currency = getMetaContent('_isoCurrency');
                    const currencySymbol = getMetaContent('_currency');
                    const currency_country_code = getMetaContent('_currency_country_code');
                    let parsedFeedpriceFloat = parseStringPriceToFloat(parsed.price, currency_country_code);
                    console.log('found exclusive voucher applying with new price: ' + feedprice);

                    const formatter = new Intl.NumberFormat(currency_country_code, {
                        style: 'currency',
                        currency: currency,
                        minimumFractionDigits: 2
                    });
                    const formattedPrice = formatter.format(parsedFeedpriceFloat).replace(/’/g, "'").replace(currencySymbol, '').trim();
                    var priceNewContainer = $('#acl_article_price--feed > .en_price--new');

                    if (priceNewContainer.length === 0) {
                        let newPriceSpan = '<span id="feedprice" class="en_price en_price--new" data-unformatted-price="' + parsedFeedprice + '">' +
                            '<span class="en_price__currency">' + currencySymbol + '&nbsp;</span>' +
                            formattedPrice +
                            '</span>';

                        let oldPriceContainer = $('#acl_article_price--feed > .en_price--old');
                        if (oldPriceContainer.length) {
                            oldPriceContainer.after(newPriceSpan);
                        } else {
                            // Fallback if '.en_price--old' does not exist
                            $('#acl_article_price--feed').append(newPriceSpan);
                        }
                    } else {
                        priceNewContainer.attr('data-unformatted-price', parsedFeedprice);
                        priceNewContainer.find('.en_price__currency').html(currencySymbol + '&nbsp;');
                        priceNewContainer.contents().last().replaceWith(formattedPrice);
                    }

                    $('#acl_feedvouchercode').val(parsed.vouchercode);

                    $('#acl_article_price--feed .en_mdl_article_detail__voucher-info-currently > strong').html(parsed.vouchercode);
                    $('#acl_article_price--feed .en_mdl_article_detail__voucher-info-text > strong').html(parsed.vouchercode);
                    $('.feedSalesPercentageBadge').text('-' + parsed.voucherpercentage + ' extra');
                    showExclusiveVoucher = true;
                } else {
                    showPromotion = false;
                }
            } catch (e) {
                showPromotion = false;
            }

        }
    });

    if (showExclusiveVoucher || showPromotion) {
        if (price_feed && price_standard) {

            price_feed.classList.remove('en_hidden');
            price_standard.classList.add('en_hidden');
            $('.feedSalesPercentageBadge').removeClass('en_hidden');

            if (voucher_code) {
                voucher_code.setAttribute('name', 'voucher');
            }
        }
    }

    if (showPromotion) {
        if ($('input[name="feed"]').length > 0) {
            $(document).trigger('promotionpriceloaded');
            $('input[name="feed"]').val('1');
            $('#acl_article_price--default').hide();
            // $( '#acl_article_price--feed' ).show();
            $('#acl_article_price--feed').removeClass('en_hidden');
            $('.en_price[itemprop="price"]').html(feedprice);
            $('.en_price[itemprop="price"]').attr('content', feedprice);
            $('[data-eec-price]').attr('data-eec-price', feedprice);
        }
    }
};

$(document).ready(function () {
    const v_cl = getViewControllerName();
    switch (v_cl) {
        case 'details':

            if (window.runExclusiveVoucherLogic) {
                badgeUpdateFn();
                $(document).on('finished_change_variant', badgeUpdateFn);
                window.runExclusiveVoucherLogic = false;
            }
            break;
    }
});

// Make available in window for legacy reasons.
window.badgeUpdateFn = badgeUpdateFn;

// Export for ES6.
export default badgeUpdateFn;
